/* ----------- APIS Paths -----------------  */
export const KMZ_UPLOAD = '/kmz/upload';
export const GET_ALL_KMZ = (network, partner) => `/kmz?network=${network}&partner=${partner}`;
export const GET_ALL_CITIES_KMZ = (network) => `/kmz/cities/${network}`;
export const GET_ALL_Regions_KMZ = (network) => `/kmz/regions/${network}`;
export const UPDATE_KMZ = (name) => `/kmz/updateKMZ/${name}`;
export const DELETE_KMZ = (name, network) => `/kmz/deleteKmzData?names=${name}&network=${network}`;
export const DELETE_Route = (id) => `/routes/deleteRoute/${id}`;
export const EXPORT_Route = (format, id) => `/routes/export/${format}/${id}`;
export const COMPARE_ROUTES = `/routes/getRouteComparisonByIds`;
export const GET_INVENTORY = (network) => `/inventory/${network}`;
export const UPDATE_INVENTORY = (id, network) => `/inventory/update/${id}?network=${network}`;
export const GET_ALL_KMZ_WITH_FILTERS = (ids, names, network, partner, regions, cities) =>
  `/kmz/kmzMapdata?ids=${ids}&names=${names}&network=${network}&partner=${partner}&regions=${regions}&cities=${cities}`;

/* ----------- Route Paths -----------------  */
export const RAN_DB_Main_PAGE = '/oko/randb';

/* ----------- Tenant -----------------  */
export const CREATE_TENANT = '/tenant/createTenant';

/* ----------- Ran DB -----------------  */

export const RAN_DB_UPLOAD_EXCEL = '/ranDb/uploadExcel';
export const RAN_DB_UPLOAD_EXCEL_WITH_PROGRESS = '/ranDb/uploadExcelWithProgress';
export const RAN_DB_UPLOAD_STATUS = (jobId) => `/ranDb/uploadExcel/status/${jobId}`;
export const RAN_DB_DOWNLOAD_EXCEL = '/ranDb/downloadExcel';
export const GET_ALL_RAN_DB_SITES = '/ranDb/getAllRanSite';
export const GET_ALL_RAN_DB_AUDIT_LOGS = '/ranDb/auditLogs';
export const RAN_DB_AUDIT_LOG_SITE = (id) => `/ranDb/auditLogs/sites/${id}`;
export const RAN_DB_CREATE_SITE = '/ranDb/createSite';
export const RAN_DB_UPDATE_SITE = (id) => `/ranDb/updateSite/${id}`;
export const RAN_DB_DELETE_SITE = (id) => `/ranDb/deleteSite/${id}`;
export const RAN_DB_BULK_REVIEW = '/ranDb/sync';
export const GET_NETWORKLAYER_DATA = '/ranDb/getNetworkLayerData';
export const GET_RAN_FIBERSITE_DATA = '/ranDb/getRANFiberSite';
export const GET_FIBER_SITE_DASHBOARD = '/ranDb/getFiberSiteDashboard';
export const GET_RAN_DB_DASHBOARD = '/ranDb/getRanDbDashboard';
export const GET_RAN_SITES_BY_STATUS = (status, type) =>
  `/ranDb/ran-sites/${type}/status/${status}`;
export const SEARCH_RAN_DB_SITES = (siteCode) => `/ranDb/ranSearch/${siteCode}?includeFtts=false`;
export const SEARCH_FIBER_SITES = (siteCode) => `/ranDb/ranSearch/${siteCode}?includeFtts=true`;

export const GET_ALL_FIBER_SITE_PLANNING_SITES = '/fiberSitePlanning/getAllSites';
export const FIBER_SITE_PLANNING_UPDATE_SITE = (id) => `/fiberSitePlanning/updateSite/${id}`;
export const FIBER_SITE_PLANNING_BULK_DELETE = '/ranDb/bulkDeleteSites';
export const FIBER_SITE_PLANNING_UPLOAD_EXCEL = '/fiberSitePlanning/uploadExcel';
export const FIBER_SITE_PLANNING_UPLOAD_STATUS = (jobId) =>
  `/fiberSitePlanning/uploadExcel/status/${jobId}`;

/* ----------- GeoServer -----------------  */

export const GET_GEOSERVER_LINKS = (network) => `/geoServer/links?network=${network}`;
export const GET_GEOSERVER_SITES = (network) => `/geoServer/sites?network=${network}`;

/* ----------- Ring Planning -----------------  */

export const GET_ALL_RING_GROUPS = '/ring/getAllRingGroups';
export const GET_ONE_RING_GROUP = (id) => `/ring/getOneRingGroup/${id}`;
export const CREATE_RING = '/ring/createRing';
export const DELETE_RING_GROUP = (id) => `/ring/deleteRingGroup/${id}`;

/* ----------- Fiber POP -----------------  */
export const GET_ALL_FIBER_POP = '/fiberPop/getAllfiberpop';
export const CREATE_FIBER_POP = '/fiberPop/create';
export const FIBER_POP_UPLOAD_EXCEL = '/fiberPop/uploadExcel';
export const FIBER_POP_BULK_REVIEW = '/fiberPop/sync';
export const FIBER_POP_UPDATE_SITE = (id) => `/fiberPop/update/${id}`;
export const FIBER_POP_BULK_DELETE = '/fiberPop/bulkDeleteSites';

/* ----------- Invoice Management Comments -----------------  */
// Admin endpoints
export const CREATE_INVOICE_COMMENT_ADMIN = '/adminInvoiceManagement/invoice/comments';
export const GET_INVOICE_COMMENTS_ADMIN = (invoiceId) =>
  `/adminInvoiceManagement/invoice/comments/${invoiceId}`;
export const UPDATE_INVOICE_COMMENT_ADMIN = (commentId) =>
  `/adminInvoiceManagement/invoice/comments/${commentId}`;
export const DELETE_INVOICE_COMMENT_ADMIN = (commentId) =>
  `/adminInvoiceManagement/invoice/comments/${commentId}`;

// Approval Person endpoints
export const CREATE_INVOICE_COMMENT_APPROVAL = '/approvalPersonInvoiceManagement/invoice/comments';
export const GET_INVOICE_COMMENTS_APPROVAL = (invoiceId) =>
  `/approvalPersonInvoiceManagement/invoice/comments/${invoiceId}`;
export const UPDATE_INVOICE_COMMENT_APPROVAL = (commentId) =>
  `/approvalPersonInvoiceManagement/invoice/comments/${commentId}`;
export const DELETE_INVOICE_COMMENT_APPROVAL = (commentId) =>
  `/approvalPersonInvoiceManagement/invoice/comments/${commentId}`;

// System vendor invoice — approval persons portal
export const CREATE_INVOICE_COMMENT_SYSTEM_APPROVAL =
  '/approvalPersonSystemInvoiceManagement/invoice/comments';
export const GET_INVOICE_COMMENTS_SYSTEM_APPROVAL = (invoiceId) =>
  `/approvalPersonSystemInvoiceManagement/invoice/comments/${invoiceId}`;
export const UPDATE_INVOICE_COMMENT_SYSTEM_APPROVAL = (commentId) =>
  `/approvalPersonSystemInvoiceManagement/invoice/comments/${commentId}`;
export const DELETE_INVOICE_COMMENT_SYSTEM_APPROVAL = (commentId) =>
  `/approvalPersonSystemInvoiceManagement/invoice/comments/${commentId}`;

// System PO workflow — System Invoice Management admin
export const CREATE_INVOICE_COMMENT_SYSTEM_ADMIN =
  '/systemInvoiceManagement/workflow/invoice/comments';
export const GET_INVOICE_COMMENTS_SYSTEM_ADMIN = (invoiceId) =>
  `/systemInvoiceManagement/workflow/invoice/comments/${invoiceId}`;
export const UPDATE_INVOICE_COMMENT_SYSTEM_ADMIN = (commentId) =>
  `/systemInvoiceManagement/workflow/invoice/comments/${commentId}`;
export const DELETE_INVOICE_COMMENT_SYSTEM_ADMIN = (commentId) =>
  `/systemInvoiceManagement/workflow/invoice/comments/${commentId}`;
